import gql from 'graphql-tag';

// export const insertCourseMutation = gql`
//   mutation InsertCourse($object: courses_insert_input!) {
//     insert_courses_one(object: $object) {
//       id
//     }
//   }
// `;

// export const updateCourseMutation = gql`
//   mutation UpdateCourse($id: uuid!, $changes: courses_set_input!) {
//     update_courses_by_pk(pk_columns: { id: $id }, _set: $changes) {
//       id
//     }
//   }
// `;

export const getCourseType = gql`
  query getCourseType($limit: Int, $offset: Int, $search: String) {
    course_type(limit: $limit, offset: $offset, where: { 
      name: { _ilike: $search } 
    }) {
      id
      name
    }
  }
`;

export const getCompanyName = gql`
 query getCompanyName($limit: Int!, $offset: Int!, $search: String) {
  courses(
    distinct_on: company_name
    order_by: { company_name: asc }
    where: { 
      company_name: { _is_null: false }
      _and: [
        { company_name: { _ilike: $search } }
      ]
    }
    limit: $limit
    offset: $offset
  ) {
    company_name
  }
}
`;



export const getCourseCategory = gql`
  query getCourseCategory {
    course_categories (order_by : {name: asc}) {
      id
      name
    }
  }
`;
export const supplierProfileData = gql`
query supplierProfileData($id: uuid!){
    dental_suppliers_by_pk(id:$id){
    id
    email
    name
    phone
    present_subscription_id
    community_id
    community_status
  }
}
`;


export const listAllCourses = gql`
  query ShowCourses($where: courses_bool_exp, $limit: Int, $offset: Int) {
    courses(where: $where, limit: $limit, offset: $offset, order_by: { created_at: desc }) {
    id
    created_at
		course_name
    	course_category_id
		contact_name
        
    type  
		startDate
		endDate
    startTime
    endTime
		presenters
		description
    	address
	    cpd_points
		number_of_seats
		early_bird_end_date
		early_bird_price
		afterwards_price
		topics_included
		learning_objectives
		event_type
		course_event_info
		sponsor_by_image
    course_banner_video
    course_banner_image
    course_gallery
		terms
		refund_policy
		company_name
		contact_email
		contact_phone
		contact_website
		status
		active_status
    register_link
    rsvp_date
    webinar_link  
    created_by_id

    
    course_registered_users_aggregate {
        aggregate {
          count
        }
      }
    }
  }
`;


export const getAllCourses = gql`
  query getAllCourses($where: courses_bool_exp, $limit: Int, $offset: Int) {
    courses(where: $where, limit: $limit, offset: $offset, order_by: { created_at: desc }) {
      id
    	created_at
		updated_at
		course_name
		course_category_id
		contact_name
        type
		startDate
		endDate
    startTime
    endTime
		presenters
		description
		address
	    cpd_points
		number_of_seats
		early_bird_end_date
		early_bird_price
		afterwards_price
		topics_included
		learning_objectives
		event_type
		course_event_info
		sponsor_by_image
    course_banner_video
    course_banner_image
    course_gallery
		terms
		refund_policy
		company_name
		contact_email
		contact_phone
		contact_website
		status
		active_status
    register_link
    
    }
  }
`;

export const getCoursesCountByStatus = gql`
  query getCoursesCountByStatus(
  $whereAll: courses_bool_exp = {}
  $whereDraft: courses_bool_exp = {}
  $where: courses_bool_exp = {}
) {
  all: courses_aggregate(where: $whereAll) {
    aggregate {
      count
    }
  }
  draft: courses_aggregate(where: $whereDraft) {
    aggregate {
      count
    }
  }
  pending: courses_aggregate(
    where: { _and: [$where, { status: { _eq: "PENDING" } }] }
  ) {
    aggregate {
      count
    }
  }
  active: courses_aggregate(
    where: {
      _and: [
        $where
        { status: { _eq: "APPROVE" }, active_status: { _eq: "ACTIVE" } }
      ]
    }
  ) {
    aggregate {
      count
    }
  }
  inactive: courses_aggregate(
    where: {
      _and: [
        $where
        { status: { _eq: "APPROVE" }, active_status: { _eq: "INACTIVE" } }
      ]
    }
  ) {
    aggregate {
      count
    }
  }
  expired: courses_aggregate(
    where: { _and: [$where, { status: { _eq: "EXPIRED" } }] }
  ) {
    aggregate {
      count
    }
  }
  approve: courses_aggregate(
    where: { _and: [$where, { status: { _eq: "APPROVE" } }] }
  ) {
    aggregate {
      count
    }
  }
  rejected: courses_aggregate(
    where: { _and: [$where, { status: { _eq: "REJECT" } }] }
  ) {
    aggregate {
      count
    }
  }
}

`;
// export const GetCourseById = gql`
//   query GetCourseById($id: uuid!) {
//     courses_by_pk(id: $id) {
//       	id
//     	created_at
// 		updated_at
// 		course_name
// 		course_category_id
// 		contact_name
//         type
// 		startDate
// 		endDate
//     startTime
//     endTime
// 		presented_by_image
// 		presented_by_name
// 		description
// 		address
// 	    cpd_points
// 		number_of_seats
// 		early_bird_end_date
// 		early_bird_price
// 		afterwards_price
// 		topics_included
// 		learning_objectives
// 		event_type
// 		course_event_info
// 		sponsor_by_image
//     course_banner_video
//     course_banner_image
//     course_gallery
// 		terms
// 		refund_policy
// 		company_name
// 		contact_email
// 		contact_phone
// 		contact_website
// 		status
// 		active_status
//     register_link
//     rsvp_date
//     webinar_link  
//     }
//   }
// `;
export const getCourseDetailsPreview = gql`
  query getCourseDetailsPreview($id: uuid!) {
    courses(where: { id: { _eq: $id } }) {
      	id
    	created_at
		updated_at
		course_name
		course_category_id
		contact_name
        type
		startDate
		endDate
    startTime
    endTime
		presenters
		description
		address
	    cpd_points
		number_of_seats
		early_bird_end_date
		early_bird_price
		afterwards_price
		topics_included
		learning_objectives
		event_type
		course_event_info
		sponsor_by_image
    course_banner_video
    course_banner_image
    course_gallery
		terms
		refund_policy
		company_name
		contact_email
		contact_phone
		contact_website
		status
		active_status
    register_link
    rsvp_date
    webinar_link  
    }
  }
`;


// export const deleteCourseFromListMutation = gql`
//   mutation DeleteCourse($id: uuid!) {
//     delete_courses_by_pk(id: $id) {
//       id
//     }
//   }
// `;


// export const updateCourseStatusMutation = gql`
//   mutation UpdateCourseStatus($id: uuid!, $status: String!) {
//     update_courses_by_pk(pk_columns: { id: $id }, _set: { active_status: $status }) {
//       id
//       active_status
//     }
//   }
// `;

// course.mutations.ts
// export const updateCourseApproveStatusMutation = gql`
//   mutation UpdateCourseStatus($id: uuid!, $status: String!) {
//     update_courses_by_pk(pk_columns: { id: $id }, _set: { status: $status }) {
//       id
//       status
//     }
//   }
// `;


//
// export const registerUserMutation = gql`
//   mutation RegisterUser($object: course_registered_users_insert_input!) {
//     insert_course_registered_users_one(object: $object) {
//       id
//       first_name
//       last_name
//       email
//       phone_number
//       description
//       course_id
//       from_id
//       created_at
//     }
//   }
// `;



// export const getRegCourseById = gql`
//   query GetCourseById($id: uuid!) {
//     courses_by_pk(id: $id) {
//     id
//     created_at
// 		updated_at
// 		course_name
// 		contact_name
//     type
// 		startDate
// 		endDate
//     startTime
//     endTime
// 		presented_by_image
// 		presented_by_name
// 		description
// 		number_of_seats
// 		event_type
// 		company_name
// 		contact_email
// 		contact_phone
// 		contact_website
// 		status
// 		active_status
//    afterwards_price
//     }
//   }
// `;

export const getCourseRegisteredUsers = gql`
  query getCourseRegisteredUsers($limit: Int!, $offset: Int!,  $where: course_registered_users_bool_exp) {
    course_registered_users(
       where: $where
      limit: $limit
      offset: $offset
      order_by: { created_at: desc }
    ) {
      id
      first_name
      last_name
      email
      phone_number
      description
      course_id
      from_id
      created_at
      webinar_status
      status
      directories_practice{
      id
      dental_practice{
      id
      logo
      }
      }
      directories_supplier{
      id
      dental_supplier{
      id
      logo
      }
      }
      directories_professional{
      id
      dental_professional{
      id
      profile_image
      }
      }
    }
  }
`;



export const getRegisteredCoursesByUser = gql`
  query GetUserRegisteredCourses(
    $where: courses_bool_exp!
    $limit: Int!
    $offset: Int!
    $loginId: uuid
  ) {
    courses(
      where: $where
      limit: $limit
      offset: $offset
      order_by: { startDate: desc }
    ) {
      id
      type
      endDate
      startDate
      startTime
      endTime
      course_name
      description
      created_at
      cpd_points
      presenters
      presented_by_name
      presented_by_image
      company_name
      webinar_link
      afterwards_price
      cpd_points
      course_category_id
      course_category {
        id
        name
      }

      course_registered_users(where: { from_id: { _eq: $loginId } }) {
        id
        webinar_status
        status
        first_name
        last_name
        from_id
      }

      dental_supplier {
        logo
      }
    }
  }
`;


// // Insert course mutation
// export const INSERT_COURSE = gql`
//   mutation InsertCourse($object: courses_insert_input!) {
//     insert_courses_one(object: $object) {
//       id
//     }
//   }
// `;

// // Update course mutation
// export const UPDATE_COURSE = gql`
//   mutation UpdateCourse($id: uuid!, $object: courses_set_input!) {
//     update_courses_by_pk(pk_columns: { id: $id }, _set: $object) {
//       id
//     }
//   }
// `;

// // Insert newsfeed mutation
// export const INSERT_NEWSFEED = gql`
//   mutation InsertNewsfeed($object: newsfeeds_insert_input!) {
//     insert_newsfeeds_one(object: $object) {
//       id
//     }
//   }
// `;


// export const updateWebinarStatus = gql`
//   mutation UpdateWebinarStatus($id: uuid!, $status: String!) {
//     update_course_registered_users_by_pk(pk_columns: { id: $id }, _set: { webinar_status: $status }) {
//       id
//       webinar_status
//     }
//   }
// `;

export const getMyCourseData = gql`
  query getMyCourseData($where: courses_bool_exp!) {
    courses(where: $where) {
    id
    course_name
    cpd_points
    address
    presenters
    startDate
    status
    type
    course_banner_image
    number_of_seats
    created_by_id
    community_id
    community_status
    community_user_type
    dental_supplier{
    business_name
    }
    course_registered_users_aggregate (where: { status: { _neq: "CANCELLED" } }) {
      aggregate {
        count
      }
    }
    }
  }
`;

export const getRegisterUserTabCounts = gql`
  query getRegisterUserTabCounts($where: course_registered_users_bool_exp!) {
    
    all: course_registered_users_aggregate(where: $where) {
      aggregate { count }
    }

    pending: course_registered_users_aggregate(
      where: { _and: [$where, { status: { _eq: "PENDING" } }] }
    ) {
      aggregate { count }
    }

    approved: course_registered_users_aggregate(
      where: { _and: [$where, { status: { _eq: "APPROVED" } }] }
    ) {
      aggregate { count }
    }

    cancelled: course_registered_users_aggregate(
      where: { _and: [$where, { status: { _eq: "CANCELLED" } }] }
    ) {
      aggregate { count }
    }

    completed: course_registered_users_aggregate(
      where: { _and: [$where, { status: { _eq: "COMPLETED" } }] }
    ) {
      aggregate { count }
    }
  }
`;


